export class TopicoResponse {
  id: number;
  nome: string;
  
  constructor(p: any) {
    this.id = p.id ?? null;
    this.nome = p.nome ?? null;
  }
}